export const UNLIMITED_CONVERSATIONS = 999_999;

export const UNLIMITED_CONVERSATIONS_LABEL = "Ilimitadas";

export const UNLIMITED_CONVERSATIONS_PHRASE = "Conversaciones ilimitadas";

const countFormat = new Intl.NumberFormat("es-CO");

export function isUnlimitedConversations(value: number | null | undefined): boolean {
  return Number(value) >= UNLIMITED_CONVERSATIONS;
}

export function formatCount(value: number | null | undefined): string {
  return countFormat.format(Number(value) || 0);
}

export function formatConversationCount(value: number | null | undefined): string {
  return isUnlimitedConversations(value) ? UNLIMITED_CONVERSATIONS_LABEL : formatCount(value);
}

export function formatConversationsWithUnit(value: number | null | undefined, unit: string): string {
  return isUnlimitedConversations(value) ? UNLIMITED_CONVERSATIONS_PHRASE : `${formatCount(value)} ${unit}`;
}

export const PER_USE_PLAN_LABEL = "Pago por uso";

export const PREPAID_PLAN_LABEL = "Prepago";

export interface PlanConversationsSource {
  conversations_included?: number | null;
  billing_mode?: string | null;
}

export interface BillingModeLabels {
  per_use: string;
  prepaid: string;
}

const DEFAULT_BILLING_MODE_LABELS: BillingModeLabels = { per_use: PER_USE_PLAN_LABEL, prepaid: PREPAID_PLAN_LABEL };

export function formatPlanConversations(
  plan: PlanConversationsSource,
  unit?: string,
  labels: BillingModeLabels = DEFAULT_BILLING_MODE_LABELS,
): string {
  if (plan.billing_mode === "per_use") return labels.per_use;
  if (plan.billing_mode === "prepaid") return labels.prepaid;
  return unit ? formatConversationsWithUnit(plan.conversations_included, unit) : formatConversationCount(plan.conversations_included);
}
